import useNetworkStatus from "../Features/Utils/useNetworkStatus";

 
const OfflineBanner = () => {
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        width: "100%",
        background: "red",
        color: "white",
        textAlign: "center",
        padding: "10px",
        zIndex: 9999,
      }}
    >
      🚫 No Internet Connection
    </div>
  );
};

export default OfflineBanner;